import { useRef } from "react";
import { useDropdown } from '../../../hooks/useDropdown';

import { PlusIcon } from "../../Shared/Icons";
import { AddWidgetOptions } from "./AddWidgetOptions";

import { getWidgetToAdd } from "./widgetJSON";

function AddWidget(props) {
  const ref = useRef();
  const [showDropdown, setShowDropdown] = useDropdown(ref);
  function onAddWidget(name) {
    let widgetToAdd = getWidgetToAdd(name)();
    widgetToAdd.position = props.position + 1;
    widgetToAdd.lesson_id = props.lesson_id;
    widgetToAdd.setWigets = props.setWidgets;
    widgetToAdd.updatedBy = props.course.author_name;

    const newArr = [...props.widgets];
    newArr.splice(props.position, 0, widgetToAdd);
    newArr.forEach((w, idx) => w.position = idx + 1);
    props.setWidgets(newArr);
  }

  return (
    <div className={!showDropdown ? "AddWidget" : "AddWidget AddWidgetActive"}>
      <div
        onClick={() => setShowDropdown(!showDropdown)}
        className="AddWidgetContent"
      >
        {showDropdown && <div className="WidgetOptionsConnectorLine" />}
        {showDropdown &&
          <div ref={ref}>
            <AddWidgetOptions onClick={onAddWidget}/>
          </div>
        }
        <div className={!showDropdown ? "AddWidgetIcon" : "AddWidgetIcon AddWidgetIconActive"}>
          <PlusIcon />
        </div>
      </div>
    </div>
  )
}

export { AddWidget };
